import { registerQuery } from 'data-fetching-client';
import { getEcosystemClient } from 'marketplace-ui-common/clients/ecosystemClient';
import { ReviewResponseJSON } from '../records/Review';

export const GET_REVIEWS = registerQuery({
  fieldName: 'reviewsResponse',
  args: ['appContext', 'queries', 'reviewType'],
  fetcher({
    appContext,
    queries,
    reviewType,
  }): Promise<{ reviews: ReviewResponseJSON[]; total: number }> {
    const client = getEcosystemClient(appContext);
    return client.post('reviews/search', {
      data: {
        ...queries,
        reviewTypes: [reviewType],
      },
    });
  },
});
